import { Control, UseFormGetValues, UseFormSetValue } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import { IFilterExpenseNote, IFilterManifest } from "../../types/interface";
import { classNames } from "../../utils/classNames";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import DateRangePicker from "../Reusable/DateRangePicker";

interface Props {
  setValue: UseFormSetValue<IFilterExpenseNote>;
  getValues: UseFormGetValues<IFilterExpenseNote>;
  reset: () => void;
  control: Control<IFilterExpenseNote, any>;
  isFilterVisible: boolean;
}

const Filter = ({
  setValue,
  getValues,
  isFilterVisible,
  reset,
  control,
}: Props) => {
  return (
    <div
      className={classNames(
        isFilterVisible ? tw`block` : tw`hidden`,
        tw`relative`
      )}
    >
      {isFilterVisible ? (
        <div className={tw`grid grid-cols-3 gap-x-4 mx-4`}>
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />

          <ComboboxFilter<IFilterExpenseNote>
            url={APIS.BRANCH}
            queryKey={"branch"}
            name={"from_branch"}
            label={"Branch"}
            params={{
              is_active: true,
            }}
            placeholder={"Search branch"}
            control={control}
          />
          <ComboboxFilter<IFilterExpenseNote>
            url={APIS.SHIP_VIA}
            queryKey={"ship-via"}
            name={"ship_via"}
            label={"Ship Via"}
            params={{
              is_active: true,
            }}
            placeholder={"Search ship via"}
            control={control}
          />
        </div>
      ) : (
        ""
      )}
      <button className={tw`absolute -top-5 right-5`} onClick={() => reset()}>
        Reset
      </button>
    </div>
  );
};

export default Filter;
